<app-modal [title]="'2FA Token'" [(visible)]="visible" (open)="onOpened()" (close)="onClosed()">
    <div #modalContent ngProjectAs="modal-content">

        <form [formGroup]="form" (ngSubmit)="onSubmit()">

            <p class="font-light">Select the authentication method below.</p>

            <app-tab-navigation [redirect]="false">

                <app-tab-panel [name]="'Token'" [id]="panels()[0]" [show]="true">
                    <ng-template #tabContent>
                        <p class="font-light">Authenticate below using the 6-digit 2FA Token in your app.</p>
                        <app-form-control-underline [(control)]="form.controls.token" [length]="6" [type]="'number'"/>

                        <app-modal-form-button-group [buttons]="['submit']" [form]="form.controls.token" 
                            [opts]="{
                                values:{
                                    submit: 'Login'
                                }
                            }"
                    />
                   </ng-template>
                </app-tab-panel>
            
                <app-tab-panel [name]="'Recovery Code'" [id]="panels()[1]">
                    <ng-template #tabContent>
                        <p class="font-light">Authenticate below using your personal Recovery Code.</p>
                        <app-form-control [(control)]="form.controls.recovery" [type]="'text'"/>

                        <app-modal-form-button-group [buttons]="['submit']" [form]="form.controls.recovery" 
                            [opts]="{
                                values:{
                                    submit: 'Login'
                                }
                            }"
                        />
                    </ng-template>
                </app-tab-panel>

            </app-tab-navigation>
            
        </form>
        
    </div>
</app-modal>